import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { History, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";
import { api, brl, fmtDateTime, errMsg } from "@/lib/api";

export const RecorrenciaAlertas = ({ onOpen, onChanged }) => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(true);
  const load = () => api.get("/benchmark/alertas").then((r) => setD(r.data)).catch(() => setD({ total: 0, items: [] }));
  useEffect(() => { load(); }, []);

  const acao = async (o, a) => {
    try {
      if (a === "adicionado") await api.patch(`/opportunities/${o.id}`, { saved: true });
      await api.post(`/benchmark/alertas/${o.id}`, { acao: a });
      toast.success(a === "adicionado" ? "Adicionada ao Pipeline" : "Alerta dispensado");
      load(); if (a === "adicionado") onChanged && onChanged();
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!d || d.total === 0) return null;
  return (
    <div data-testid="pipeline-recorrencia-alertas" className="mb-4 rounded-xl border border-violet-200 bg-violet-50/60 p-3">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between text-left">
        <span className="flex items-center gap-2 text-sm font-bold text-violet-900"><History className="h-4 w-4" /> {d.total} oportunidade(s) recorrente(s) no Radar — já compradas antes pelo órgão ou recorrentes na UF</span>
        {open ? <ChevronUp className="h-4 w-4 text-violet-700" /> : <ChevronDown className="h-4 w-4 text-violet-700" />}
      </button>
      {open && (
        <div className="mt-2 grid gap-2 md:grid-cols-2 xl:grid-cols-3">
          {d.items.map((o) => (
            <div key={o.id} data-testid={`rec-alerta-${o.id}`} className="rounded-lg border border-violet-100 bg-white p-3 text-xs">
              <div className="mb-1 flex items-center justify-between gap-2">
                <span className="rounded-full bg-violet-600 px-2 py-0.5 text-[10px] font-bold text-white">♻ Recorrente</span>
                <span className="text-slate-400">{o.uf} · encerra {fmtDateTime(o.data_encerramento_proposta)}</span>
              </div>
              <div className="font-semibold text-slate-700 line-clamp-1">{o.orgao_razao_social}</div>
              <p className="line-clamp-2 text-slate-500">{o.objeto}</p>
              <div className="mt-1 text-[11px] text-violet-700">{o.recorrencia?.compras_orgao ? `${o.recorrencia.compras_orgao} compra(s) anterior(es) do órgão` : `${o.recorrencia?.itens_uf || 0} itens semelhantes na UF`}{o.recorrencia?.desconto_medio_pct ? ` · desconto médio ${o.recorrencia.desconto_medio_pct}%` : ""}{o.valor_estimado ? ` · ${brl(o.valor_estimado)}` : ""}</div>
              <div className="mt-2 flex flex-wrap gap-1">
                <button data-testid={`rec-ver-${o.id}`} onClick={() => onOpen(o.id)} className="rounded border border-slate-200 px-2 py-1 font-semibold text-slate-600 hover:bg-slate-50">Ver histórico</button>
                <button data-testid={`rec-ws-${o.id}`} onClick={() => navigate(`/participar/${o.id}`)} className="rounded border border-sky-200 px-2 py-1 font-semibold text-sky-700 hover:bg-sky-50">Analisar no Workspace</button>
                <button data-testid={`rec-add-${o.id}`} onClick={() => acao(o, "adicionado")} className="rounded bg-violet-600 px-2 py-1 font-semibold text-white">Adicionar ao Pipeline</button>
                <button data-testid={`rec-dispensar-${o.id}`} onClick={() => acao(o, "dispensado")} className="rounded px-2 py-1 font-semibold text-slate-400 hover:text-rose-600">Dispensar</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
